import { render, staticRenderFns } from "./HandPaperTopBarIcon.vue?vue&type=template&id=508372d8&"
import script from "./HandPaperTopBarIcon.vue?vue&type=script&lang=js&"
export * from "./HandPaperTopBarIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports